import type { PortableTextBlockComponent } from '@portabletext/react';

const H3: PortableTextBlockComponent = ({ children }) => (
  <h3 className="my-6 text-2xl font-medium first:mt-0">{children}</h3>
);

export default H3;

export const H3Html: PortableTextBlockComponent = ({ children }) => (
  <h3>{children}</h3>
);
